import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DistributionAccount} from '../../../distribution-account/distribution-account.model';
import {isMultiShareConfigSupported} from '../../../segment-multi-share/domain';
import {TargetModel} from '../../../target/target.model';

@Component({
  selector: 'app-segment-share-item',
  templateUrl: 'item.component.html',
  styleUrls: ['item.component.scss']
})
export class SegmentShareItemComponent implements OnInit {
  @Input() accountValue!: DistributionAccount;
  @Input() system!: TargetModel;
  @Output() accountValueChange = new EventEmitter();

  isMultiShareSupported = false;

  constructor() {
  }

  ngOnInit() {
    this.isMultiShareSupported = isMultiShareConfigSupported(this.system.targetId as number);
  }

  focusOnForeignId() {

    if (this.accountValue && this.accountValue.userProvidedForeignId) {
      this.accountValue.selected = true;
    }
  }

  blurOnForeignId() {

    if (this.accountValue && this.accountValue.userProvidedForeignId && !this.accountValue.foreignIdForCurrentSegment) {
      this.accountValue.selected = false;
    }
  }
}
